import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    organization: {},
    persona: {},
    personaType: {},
    role: {},
    user: {},
    error: {},
    subrole: null,
    userCurrentEnrollmentStep: null,
  },
  reducers: {
    setUserData: (state, action) => {
      Object.assign(state, action?.payload || {}, { error: {} });
    },
    setUserError: (state, action) => {
      Object.assign(state.error, action?.payload || {});
    },
    setUserCurrentEnrollmentStep: (state, action) => {
      state.userCurrentEnrollmentStep = action?.payload;
    },
  },
});

export const { setUserData, setUserError, setUserCurrentEnrollmentStep } = userSlice.actions;

export default userSlice.reducer;
